module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightheavysnow-a66e86c00c75fdd0619ced33f34e2598.png";